export { default as isHexColor } from 'validator/lib/isHexColor';
